import {ElementRef, QueryList, ViewChild, ViewChildren, Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {MatFormField} from '@angular/material/form-field';
import { MatPaginator } from '@angular/material/paginator';
import {MatSort, SortDirection} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FabTableState, filterStateChange, process} from '@fabric/components/table-filter/data-query';
import { MaintenanceDestinatario } from 'src/app/models/MaintenanceDestinatario';
import { NotificationService } from 'src/app/services/notification.service';
import { SecurityService } from 'src/app/services/security.service';
import {catchError, concat, of, forkJoin, map, Observable, ObservableInput, EMPTY} from 'rxjs';
import { DestinatarioService } from 'src/app/services/destinatario.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserFunctionCode } from 'src/app/constants/UserFunctionCode';
import { PopupCancelDialogComponent } from 'src/app/shared-components/popup-cancel-dialog/popup-cancel-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ErrorCodes } from 'src/app/constants/ErrorCodes';
import {
  FabDateFilterOperator,
  RemDateFilterComponent
} from '../../shared-components/table-filter/date-filter/date-filter.component';
import {RemNumberFilterComponent} from '../../shared-components/table-filter/number-filter/number-filter.component';
import {RemStringFilterComponent} from '../../shared-components/table-filter/string-filter/string-filter.component';
import { DestinoTransportistasService } from 'src/app/services/destinoTransportista.service';

@Component({
  selector: 'app-destinatario-maintenance',
  templateUrl: './destinatario-maintenance.component.html',
  styleUrls: ['./destinatario-maintenance.component.scss']
})
export class DestinatarioMaintenanceComponent implements OnInit {
  columnsToDisplay: string[] = ["codDealer", "nombreDealer", "dlDomicilio",
"dlCiudad", "dlDescPcia", "dlCodPcia","dlCodPostal","dlPais","nroIibb","nroCuit", "duns",
"tipoDocAfip", "email", "condicionIva", "observaciones", "estado","fecCreacion","usrCreacion","fecModif",
"usrModif","isEdit"];

  dataSource: MatTableDataSource<MaintenanceDestinatario> = new MatTableDataSource<MaintenanceDestinatario>();
  rowsToModify: any = [];
  rowsToAdd: any = [];
  activeRelationCodDealer: String[] = [];
  TABLE_DATA: MaintenanceDestinatario[] = [];
  ORIGINAL_TABLE_DATA: MaintenanceDestinatario[] = [];
  columnsSchema: any = this.columnsToDisplay;
  operators = ['contains', 'eq', 'neq'];
  dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  canAddOrEdit: boolean = false;
  today: object = new Date();
  // @ts-ignore
  currentDate = this.today.toISOString().split('T')[0];
  resultsLength = 0;
  pageSize = 10;
  state: FabTableState = {
      skip: 0,
      take: 5,
      filter: [],
      sort: []
  };
  selector: string;
  @ViewChild(MatPaginator) matPaginator: MatPaginator;
  @ViewChild(MatSort) matSort: MatSort;
  @ViewChildren('tableFilter') tableFilters: QueryList<RemStringFilterComponent | RemNumberFilterComponent | RemDateFilterComponent>;
  @ViewChild('dataTable', {read: ElementRef}) dataTable: ElementRef;

  initialSortField = ['id'];
  initialSortDirection: SortDirection = 'desc';
  maintenanceDestinatarios: MaintenanceDestinatario[] = [];
  isLoading: boolean = false;
  initialLoadingCompleted = false;

  public get saveButtonDisabled() {
    return (this.TABLE_DATA.filter(element => element.isEdit).length == 0 &&
      this.TABLE_DATA.filter(element => element.isAdd).length == 0) ||
      !this.validateAllRows()
  }

  public isDirty(row: MaintenanceDestinatario, column: string) {

    var toReturn;

    if(row.isAdd){
      toReturn = false;
    } else {

    // @ts-ignore
    toReturn = (row[column] != row.originalData[column])
    }

    return toReturn;
  }


  constructor(
    private notificationService: NotificationService,
    private securityService: SecurityService,
    public dialog: MatDialog,
    private destinatarioService: DestinatarioService,
    private destinoTransportistasService: DestinoTransportistasService,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef) {
  }

  ngOnInit(): void {
      this.canAddOrEdit = this.securityService.can(UserFunctionCode.MAINTENANCE);
      this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
      this.isLoading = true;
  }

  ngAfterViewInit() {
    this.fetchInitialData();
  }

  fetchInitialData() {
    this.initialLoadingCompleted = false;
    this.matSort.active = this.initialSortField[0];
    this.matSort.direction = this.initialSortDirection;
    this.matSort.sortChange.emit();
    this.cdr.detectChanges();
    this.tableFilters.toArray().forEach((x) => x.clearFilter());
    this.requestPage().subscribe(() => {
      this.initialLoadingCompleted = true;
    });
  }

  public filterChange(event:any) {
    this.state.skip = 0;
    if (this.matPaginator) {
      this.matPaginator.pageIndex = 0;
    }
    // @ts-ignore
    this.state.filter = filterStateChange(event, this.state.filter);
    this.updatePageState();
}

  getDestinoTransportistaRelations() {
    this.destinoTransportistasService.getDistinctDestino().subscribe({
      next: (data: String[]) => {
        this.activeRelationCodDealer = data;
      },
      error: (err: string) => {
        this.notificationService.open(err, 'error');
      }
    });
  }

  requestPage(): Observable<any> {
    return this.destinatarioService.getPage(
      this.matPaginator.pageIndex,
      this.matPaginator.pageSize,
      [this.matSort?.active ?? this.initialSortField],
      this.matSort?.direction ?? this.initialSortDirection,
      this.state.filter ?? [],
    ).pipe(
      map((response) => {
        this.maintenanceDestinatarios = response.data;
        this.dataSource = new MatTableDataSource<MaintenanceDestinatario>(this.maintenanceDestinatarios);
        this.TABLE_DATA = this.maintenanceDestinatarios;
        for (const row of this.dataSource.data) {
          row.isEdit = false;
          row.isAdd = false;
          row.isSave = false;
          row.originalData = JSON.parse(JSON.stringify(row));
        }
        this.resultsLength = response.total;
        this.matPaginator.pageIndex = response.page;
        this.matPaginator.pageSize = response.pageSize;
        this.isLoading = false;
        return EMPTY;
      }), catchError((error) => {
        this.notificationService.open(this.notificationService.getErrorByCode(error.error.errorCode), 'error');
        this.dataSource = new MatTableDataSource<MaintenanceDestinatario>([]);
        this.resultsLength = 0;
        this.isLoading = false;
        return EMPTY;
      })
    );
  }

  updatePageState() {
    if (this.canExit() && this.initialLoadingCompleted) {
      this.isLoading = true;
      this.requestPage().subscribe(() => {
        this.isLoading = false;
      });
    }
  }

  refresh(){
    this.dialog
        .open(PopupCancelDialogComponent)
        .afterClosed()
        .subscribe((confirm: any) => {
            if (confirm) {
                // this.fetchData();
            }
        })
      }

  processData() {
    this.dataSource.data = process(this.TABLE_DATA, this.state);
    this.isLoading = false;
  }

  sortDataByModif(){
    this.TABLE_DATA.sort(function(a, b)
    {
        var va = (a.fecModif === undefined || null) ? new Date(a.fecCreacion) : new Date(a.fecModif),
            vb = (b.fecModif === undefined || null) ? new Date(b.fecCreacion) : new Date(b.fecModif);

        // @ts-ignore
        return vb - va;
    } );
  }

  sortTableById() {
    this.TABLE_DATA.sort((a, b) => {
      // @ts-ignore
      return b.id - a.id;
    });
  }

  addRow() {
      console.log("add row");
      let newRow = new MaintenanceDestinatario;
      newRow.estado = true;
      newRow.isAdd = true;
      newRow.isSave = true;
      newRow.usrCreacion = this.securityService.LOGGED_USER['gmin'];
      this.dataSource.data.unshift(newRow);

      this.processData();
  }

  editRow(row: MaintenanceDestinatario) {
    console.log("edit row");
      if (!row.isAdd) {
          row.isEdit = true;
          row.isSave = true;
          row.usrModif = this.securityService.LOGGED_USER['gmin'];
      }

      if (row.isAdd) {
        row.isEdit = true;
    }
  }

  cancelRow(row: MaintenanceDestinatario) {

    if(row.isAdd) {
      this.TABLE_DATA = this.TABLE_DATA.filter((item) => {
        return item !== row;
      })
    } else {

      // console.log(row.originalData);

      row.id = row.originalData.id;
      row.codDealer = row.originalData.codDealer;
      row.nombreDealer = row.originalData.nombreDealer;
      row.duns = row.originalData.duns;
      row.dlDomicilio = row.originalData.dlDomicilio;
      row.dlCiudad = row.originalData.dlCiudad;
      row.dlCodPcia = row.originalData.dlCodPcia;
      row.dlDescPcia = row.originalData.dlDescPcia;
      row.dlCodPostal = row.originalData.dlCodPostal;
      row.dlPais = row.originalData.dlPais;
      row.nroIibb = row.originalData.nroIibb;
      row.nroCuit = row.originalData.nroCuit;
      row.observaciones = row.originalData.observaciones;
      row.email = row.originalData.email;
      row.tipoDocAfip = row.originalData.tipoDocAfip;
      row.condicionIva = row.originalData.condicionIva;
      row.estado = row.originalData.estado;
      row.usrModif = row.originalData.usrModif;

      row.isSave = false;
      row.isEdit = false;

    }
    this.processData();
  }



  save() {
    let inactiveObservables: ObservableInput<any>[] = [];
    let activeObservables: ObservableInput<any>[] = [];
    let errors: HttpErrorResponse[] = [];
    let saved = 0;
    let firstValidation: Boolean = this.validateAllRows();

    if(firstValidation){
      this.isLoading = true;
      this.TABLE_DATA.filter((item) => item.isSave)
      .forEach((row) => {
          let observableType = row.estado ? activeObservables : inactiveObservables;
          // console.log("test");
          // console.log(observableType);
          if (this.dirtyRow(row)) {
            observableType.push(
              this.destinatarioService.addUpdateUser(row, row.isAdd)
                .pipe(
                  map((res: MaintenanceDestinatario) => {
                    // console.log("Response: ");
                    // console.log(row);
                    // console.log(res);
                    // console.log(res.nombreDealer);
                    row.originalData = res;
                    row.isEdit = false;
                    row.isAdd = false;
                    row.isSave = false;
                    row.id = res.id;
                    row.fecModif = res.fecModif;
                    saved++;
                  }),
                  catchError((err: HttpErrorResponse) => {
                    errors.push(err);
                    return of(null);
                  })
                )
            );
          }else{
            this.cancelRow(row);
          }
        }
      );


      concat(forkJoin(inactiveObservables), forkJoin(activeObservables)).subscribe({
        next: undefined,
        error: undefined,
        complete: () => {
          if (errors.length == 0 && saved > 0) {
            this.notificationService.open(ErrorCodes.SAVED, 'success');
            this.sortTableById();
            this.processData();
          } else {
            const errorCounts = errors.map(err => err.error.errorMessage).reduce((accumulator, value) => {
              // @ts-ignore
              return {...accumulator, [value]: (accumulator[value] || 0) + 1};
            }, {});
            let errorMessage = `${saved} filas guardadas. ${errors.length} filas tienen errores:`
            .concat(...Object.entries(errorCounts).map(([msg, count]) => `\n${msg} (${count})`));
            this.notificationService.open(errorMessage, 'error');
          }
          this.isLoading = false;
        }
      });
    } else {
        this.notificationService.open(ErrorCodes.INVALID_DATA, 'error');
        this.isLoading = false;
    }
  }


  private validateRow(row: MaintenanceDestinatario) {

    return  /^([A-Za-z]{1,2})$/.test(row.dlCodPcia) &&
    /^([a-zA-Z0-9]{1,10})$/.test(row.dlCodPostal) &&
    /^([A-Za-z]{1,2})$/.test(row.dlPais) &&
    /^([0-9-]{1,18})$/.test(row.nroIibb) &&
    /^([0-9-]{1,18})$/.test(row.nroCuit) &&
    /^([0-9]{1,2})$/.test(row.tipoDocAfip) &&
    row.codDealer.length > 0 &&
    row.nombreDealer.length > 0 &&
    row.dlDomicilio.length > 0 &&
    row.dlCiudad.length > 0 &&
    row.dlDescPcia.length > 0 &&
    !this.idExistsInTable(row) &&
    !this.isEstadoInactiveAndActiveRelation(row);
  }

  public validateAllRows() {
    return this.TABLE_DATA.filter(element => element.isSave).every((row) => this.validateRow(row))
  }

  private dirtyRow(row: MaintenanceDestinatario) {

    let isDirty = false;
    if(row.isAdd){
      return true;
    }else {
      for (const [key, value] of Object.entries(row)) {
        if(key !== 'fecCreacion' && key !== 'usrModif' && key !== 'fecModif'
              && key !== 'isEdit' && key !== 'isSave' && key !== 'isAdd' && key !== 'originalData'){
          // @ts-ignore
          isDirty = row[key] !== row.originalData[key];
          if(isDirty)
            return true;
        }
      }
    }

    return isDirty;
  }


  private dirtyCheck(): boolean {
    return !this.TABLE_DATA.every((row) => {
      return !row.isEdit;
    })
  }

  idExistsInTable(row: MaintenanceDestinatario) {
    if (row.estado) {
      return this.TABLE_DATA.filter((element) => {
        return row != element &&
          row.codDealer == element.codDealer &&
          element.estado;

      }).length > 0;
    } else {
      return false;
    }
  }

  checkId(row: MaintenanceDestinatario, control: MatFormField) {
    if (this.idExistsInTable(row)) {
      this.notificationService.open(ErrorCodes.DUPLICATE_SOLICITANTE, "warn");
      control._control.ngControl?.control?.setErrors({'id-already-exists':true});
    }
  }

  checkActiveRelation(row: MaintenanceDestinatario, control: MatFormField){
    // console.log(row.codDealer);
    // console.log(this.activeRelationCodDealer);
    if(this.isEstadoInactiveAndActiveRelation(row)){
      this.notificationService.open(ErrorCodes.DESTINO_RELATIONSHIP_ACTIVE, 'error');
      control._control.ngControl?.control?.setErrors({'relation-is-active':true});
    }
  }

  isEstadoInactiveAndActiveRelation(row: MaintenanceDestinatario){
    row.isActiveRelation = this.activeRelationCodDealer.includes(row.codDealer);
    return ((!row.estado) && row.isActiveRelation)
  }



  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.dirtyCheck()) {
      return confirm("You have unsaved changes. Leave page anyway?");
    } else {
      return true;
    }
  }

  onSortChange() {
    this.matPaginator.pageIndex = 0;
    this.updatePageState();
  }
}
